import { Response } from '../../utils/interfaces/response';
import {
  PageResult,
  Periodo,
  PeriodoBanner,
  PeriodoDTO,
} from '../../utils/models';
import http from '../http/http';

export class PeriodService {
  getAllPeriods(
    pageSize?: number,
    pageNumber?: number,
    ordenar?: string,
    dir?: string,
    filtro?: string,
    inactivos?: boolean,
  ) {
    return http.get<Response<PageResult<PeriodoDTO[]>>>('/Periodo', {
      params: { pageSize, pageNumber, ordenar, dir, filtro, inactivos },
    });
  }

  updateStatusPeriod(
    id: string,
    level: string,
    programSuffix: string,
    isSemesterBusiness: boolean,
    status: boolean,
  ) {
    return http.post<Response<never>>(
      `/Periodo/${id}/Estatus`,
      {},
      {
        params: {
          nivel: level,
          sufijoPrograma: programSuffix,
          esSemestreEmpresarial: isSemesterBusiness,
          status,
        },
      },
    );
  }

  deletePeriod(
    id: string,
    level: string,
    programSuffix: string,
    isSemesterBusiness: boolean,
  ) {
    return http.delete<Response<never>>(`/Periodo/${id}`, {
      params: {
        nivel: level,
        sufijoPrograma: programSuffix,
        esSemestreEmpresarial: isSemesterBusiness,
      },
    });
  }

  createPeriod(period: PeriodoDTO) {
    return http.post<Response<Periodo>>('/Periodo', period);
  }

  updatePeriod(period: PeriodoDTO) {
    return http.put<Response<Periodo>>('/Periodo', period);
  }

  getPeriodById(
    periodId: string,
    level: string,
    programSuffix: string,
    isSemesterBusiness: boolean,
  ) {
    return http.get<Response<PeriodoDTO>>(`/Periodo/${periodId}`, {
      params: {
        nivel: level,
        sufijoPrograma: programSuffix,
        esSemestreEmpresarial: isSemesterBusiness,
      },
    });
  }
  getBannerPeriodValid(
    periodId: string,
    level: string,
    programSuffix: string,
    isSemesterBusiness: boolean,
  ) {
    return http.get<Response<PeriodoBanner>>(
      `/Periodo/${periodId}/ValidarPeriodo`,
      {
        params: {
          nivel: level,
          sufijoPrograma: programSuffix,
          esSemestreEmpresarial: isSemesterBusiness,
        },
      },
    );
  }
}
